import api from '@/api/api.js'

export default {
    getAssurances() {
        const promise = api.clinique().get('/assurances')
        return promise.then(response => response.data)
    },

    getSocieteByAssurance(assurance_id) {
        const promise = api.clinique().get('/assurances/souscripteurs/'+assurance_id+'/liste')
        return promise.then((response) => response.data)
    },

    getFactureRembourse(data) {
        const promise = api.clinique().post('/assurances/facture/demande-rembourse', data)
        return promise.then(response => response.data)
    },

    getGroupeAssuranceActif() {
        const promise = api.clinique().get('/groupes/assurances/actif')
        return promise.then(response => response.data)
    },

    getInfoPatientAssure(patient_id) {
        const promise = api.clinique().get('/patients/'+patient_id+'/info_assure')
        return promise.then(response => response.data)
    },

}